import { getView, rejectAuth } from '@/lib/utils';

export default {
  path: '',
  name: 'home',
  component: getView('pages/PageLogin'),
  beforeEnter: rejectAuth,
};
